<template>
<div class="modalprint">
      <div :id="'Modalprint_'+ item._id" :ref="'Modalprint_' + item._id" style="position:relative">
          <h2 class="text-xl font-bold mb-3 tracking-wider uppercase"><span v-if="item.refund">REFUNDED</span><span v-else>DELIVRY</span>  NOTE <span v-if="item.type=='echange'">(ECHANGE)</span></h2>
              <!-- Profile tab -->
        
            <div class="flex justify-between">
                  <div class="w-full md:w-1/3">
                      <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Name:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.order.customer.fullName}} </span></label>
                  </div> 
                    <div class="w-full md:w-1/3">
                      <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Phone:</span> <span class="text-black-800 mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;">{{item.order.customer.phone}} </span></label>
                  </div> 
            </div>   
              <div class="flex justify-between">
                  <div class="w-full md:w-1/3">
                      <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Shipping date:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{$moment(item.date).format('YYYY-MM-DD')}} </span></label>
                  </div> 
                    <div class="w-full md:w-1/3">
                      <label v-if="item.order.customer.shippingPhone" class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Phone 2:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.order.customer.shippingPhone}} </span></label>
                  </div> 
              </div>
              <div class="flex justify-between">
                <div class="w-full">
                <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Address:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.address}} </span></label>
                </div>
              </div>
              <div class="flex justify-between">
                    <div class="w-full md:w-1/3">
                      <label v-if="item.zone" class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Zone:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.zone.name}} </span></label>
                      <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Confirmed:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.orderObjet.teleConsultantConfirm?item.orderObjet.teleConsultantConfirm.fullName?item.orderObjet.teleConsultantConfirm.fullName:'':''}} </span></label>
                    </div> 
                      <div class="w-full md:w-1/3">
                          <label v-if="item.courier" class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Livreur:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.courier.fullName}} </span></label>
                          <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Store:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.seller.company}} </span></label>
                      </div>  
              </div>  
              <div  class="flex justify-between mb-2">
                <div class="w-full">
                <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Comment:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{item.order.comment}} </span></label>
                </div>
              </div>  
              <!-- <div v-if="idWharhouse && idWharhouse.phone" class="flex justify-between mb-2">
                <div class="w-full">
                <label class="text-black-700 block mb-2 text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">Service après-vente:</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 mb-2 text-xs uppercase tracking-wide">{{idWharhouse.phone}} </span></label>
                </div>
              </div>   -->
              
            <p class="size-m leading-5 font-bold text-black">
              Order contenus
          </p>             
          <table class="min-w-full">
              <thead class="justify-between" >
              <tr class="border border-black" >
                  <th  class="px-2 text-left leading-4 text-black tracking-wider">
                  <span class="text-black">#</span>
                  </th>
                  <th style="font-size: 0.75rem;line-height: 1.20rem;"  class="px-2 text-left text-xs leading-4 text-black tracking-wider">
                  <span class="text-black">Item</span>
                  </th>
                  <th style="font-size: 0.75rem;line-height: 1.20rem;" class="px-2 text-center text-xs leading-4 text-black tracking-wider">
                  <span class="text-black">Qty</span>
                  </th>
                  <th style="font-size: 0.75rem;line-height: 1.20rem;" class="px-2 text-center text-xs leading-4 text-black tracking-wider">
                  <span class="text-black">Unit Price</span>
                  </th>

                  <th style="font-size: 0.75rem;line-height: 1.20rem;" class="px-2 text-center text-xs leading-4 text-black tracking-wider">
                  <span class="text-black">Amount</span>
                  </th>
                  <!-- <th style="font-size: 0.75rem;line-height: 1.20rem;" class="px-2 text-center text-xs leading-4 text-black tracking-wider">
                      <span class="text-black">QR</span>
                  </th> -->
              </tr>
              </thead>
              <tbody class="bg-white w-full">
              <tr v-for="(el, index) in item.order.details" :key="index"  class="bg-white border border-black">
                  <td class="px-2 whitespace-no-wrap">
                    <span style="font-size: 0.75rem;line-height: 1.20rem;" class="px-2 text-xs whitespace-no-wrap text-black">{{index+1}}</span>
                  </td>
                  <td class="" >
                  <span style="font-size: 0.75rem;line-height: 1.20rem;white-space: initial;" class="px-2 text-xs  whitespace-no-wrap text-black">{{el.product.name}}</span>
                  </td>
                  <td class="px-2 text-center whitespace-no-wrap text-black">
                  <span class="size-m leading-5 font-semibold">{{el.quantity}}</span>
                  </td>
                  <td class="px-2 text-center whitespace-no-wrap text-black">
                  <span class="size-m leading-5">{{ el.unitPrice}}</span>
                  </td>
                  <td class="px-2 text-center whitespace-no-wrap text-black">
                  <span class="size-m leading-5 font-semibold">{{ el.unitPrice*el.quantity}}</span>
                  </td>
                  <!-- <td class="px-2 text-center whitespace-no-wrap">
                    <div v-if="el.product.verificationLink" class="flex justify-center items-center">
                      <qrcode-vue 
                        :value="el.product.verificationLink" 
                        :size="60" 
                        level="M"
                        render-as="svg"
                      ></qrcode-vue>
                    </div>
                    <span v-else class="text-xs text-gray-400">-</span>
                  </td> -->
              </tr>
              </tbody>
          </table>
          <div class="py-2 ml-auto w-full sm:w-2/4 lg:w-1/4">
              <div class="flex justify-between mb-3">
                  <div class="text-black text-right flex-1" style="font-size: 0.75rem;">Total: </div>
                  <div class="text-right w-40">
                      <div class="text-black-800 font-medium" x-html="netTotal" style="font-size: 0.75rem;"><span v-if="item.refund">-</span> {{item.order.totalPrice}}</div>
                  </div>
              </div>
          </div>
         
          <!-- <div class="py-1 text-center mr-5 barcode-img"> <svg :id="item.trackingNumber"></svg></div> -->
          <div class="py-1 mr-5 barcode-img flex justify-between items-center">
           
           
            
           
            <div 
                v-if="item.order.details.length === 1 && item.order.details[0].product && item.order.details[0].product.verificationLink" 
                class="flex flex-col items-center"
            >
                <qrcode-vue 
                    :value="item.order.details[0].product.verificationLink" 
                    :size="70" 
                    level="M"
                    render-as="svg"
                ></qrcode-vue>
                <span style="font-size: 0.5rem;" class="text-black mt-1">Scanner pour vérifier</span>
            </div>
            <div v-else></div>

            <div class="text-right">
                <vue-barcode :value="item.trackingNumber" tag="img"></vue-barcode>
            </div>


        </div>
           <div class="flex w-full received" style="padding: 5px;">
            <label v-if="idWharhouse && idWharhouse.phone" class="text-black-700 block  text-xs uppercase tracking-wide" style="font-size: 0.75rem;line-height: 1.20rem;"><span class="font-bold">SAV :</span> <span style="font-size: 0.75rem;line-height: 1.20rem;" class="text-black-800 text-xs uppercase tracking-wide">{{idWharhouse.phone}} </span></label>
              <!-- <span class="px-5 py-2 w-full border-black border text-black-500 rounded">RECEIVED BY:
                  <p><span class=" py-4 whitespace-no-wrap border-b text-blue-900 border-gray-500text-xs leading-5">Name and signature:</span></p>
              </span>              -->
          </div>
    
    
      </div> 
      <!--shipp list livreur -->
       <div :id="'ModalprintList_'+ item._id" class="shipp-print">
         <label class="text-black  block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"><span class="font-bold">Courier:</span> <span v-if="item.courier" style="font-size: 0.43rem;" class="text-black text-xs tracking-wide">{{item.courier.fullName||item.courier.email }} </span></label>
          <label class="text-black  block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"><span class="font-bold">Shipping address:</span> <span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide">{{item.address }} </span></label>
          <table class="mb-0"><tbody class="bg-white">
                    
        
                    <tr class="w-full">
                      <td class="align-top"  style="width: 50% !important;border: none !important;">
                          <label class="text-black block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"><span class="font-bold">Customer:</span> <span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide">{{item.order.customer.fullName}} </span></label>
                          <label class="text-black block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;;"><span class="font-bold">Phone:</span> <span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide">{{item.order.customer.phone}} </span></label>
                      </td>
                      <td class="align-top" colspan="2" style="width:50% !important;border: none !important;">
                         <label class="text-black block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"><span class="font-bold">Order NO:</span> <span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide"> {{$f.getIdbySplit(item.order.id)}}</span></label>
                         <label class="text-black  block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"><span class="font-bold">Traking Number:</span> <span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide">{{item.trackingNumber }} </span></label>
                          
                      </td>
                    </tr> 
                </tbody>     
          </table>          
          <!-- Profile tab -->      
          <p class="leading-5 font-bold text-black"  style="font-size: 0.43rem;line-height: 1.10rem;">Order items</p>             
          <table class="min-w-full">
                <thead class="justify-between" >
                <tr class="border border-black" >
                    <th style="font-size: 0.43rem;line-height: 0.60rem;" class="px-1 text-left leading-4 text-black tracking-wider">
                    <span class="text-black">#</span>
                    </th>
                    <th style="font-size: 0.43rem;line-height: 0.60rem;" class="px-1 text-left  leading-4 text-black tracking-wider">
                      <span class="text-black">Item</span>
                    </th>
                    <th style="font-size: 0.43rem;line-height: 0.60rem;" class="px-1 text-center  leading-4 text-black tracking-wider">
                    <span class="text-black">Quantity</span>
                    </th>
                    <th style="font-size: 0.43rem;line-height: 0.60rem;" class="px-1 text-center leading-4 text-black tracking-wider">
                    <span class="text-black">Unit price</span>
                    </th>

                    <th style="font-size: 0.43rem;line-height: 0.60rem;" class="px-1 text-center  leading-4 text-black tracking-wider">
                    <span class="text-black">Amount</span>
                    </th>
                </tr>
                </thead>
                <tbody class="bg-white">
                   <!-- <trbodytable v-for="(el, index) in item.order.details" :key="index" :prod="el" :index="index"/> -->
                    <tr class="bg-white border border-black" v-for="(prod, index) in item.order.details" :key="index" >
                      <td style="padding-left:3px;padding-right:3px" class=" whitespace-no-wrap text-black">
                          <span style="font-size: 0.43rem;line-height: 0.70rem;" class="text-xs text-black">{{index+1}}</span>
                      </td>
                      <td style="padding-left:3px;padding-right:3px">
                        <span style="font-size: 0.43rem;line-height: 0.60rem;white-space: initial;" class="text-xs overflow-visible whitespace-no-wrap text-black">{{prod.product.name}}</span>
                      </td>
                      <td style="padding-left:3px;padding-right:3px" class=" text-center whitespace-no-wrap text-black">
                      <span style="font-size: 0.43rem;line-height: 0.70rem;" class="text-xs text-black">{{prod.quantity}}</span>
                      </td>
                      <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
                      <span style="font-size: 0.43rem;line-height: 0.70rem;" class="text-xs text-black">{{ prod.unitPrice}}</span>
                      </td>
                      <td style="padding-left:3px;padding-right:3px" class="text-center whitespace-no-wrap text-black">
                      <span style="font-size: 0.43rem;line-height: 0.70rem;" class="text-xs text-black">{{ prod.unitPrice*prod.quantity}}</span>
                      </td>
                  </tr> 
                </tbody>
          </table>
          <div class="ml-auto w-full sm:w-2/4 lg:w-1/6" style="border-top:1px solid #000;margin-top:4px">
                <div class="flex justify-between">
                    <div class="text-black text-right size-m flex-1 text-xs" style="font-size: 0.43rem;">Total: </div>
                    <div class="text-right" style="width: 18mm; margin-right:5px">
                        <div class="text-black text-xs" x-html="netTotal" style="font-size: 0.43rem;"><span v-if="item.refund">-</span> {{item.order.totalPrice}}</div>
                    </div>
                </div>
          </div>
      </div>
      <!--/shipp list courier --> 
</div>
</template>
<script>
import trbodytable from '@/views/shippings/tableProducts.vue'

//var JsBarcode = require('jsbarcode');
export default {
  components: {
      trbodytable,
    },
    data() {
    return { 
      dropdownPopoverShow: false,
      usernameTeleconsul:'',
      image:"",
      traking:this.item.trackingNumber
    };
    },
    props: {
        config: { required: true, type: Object},
        item:{ default: [] },    
        idWharhouse: { type: Object},      
    },
    // watch: {
    //     'item.trackingNumber': function () {
    //         this.traking=this.item.trackingNumber;
    //         JsBarcode("#"+this.traking, this.traking, {format: "code39", fontOptions: "bold"});
    //     }
    // },  
    computed: {
      formattedDate() {
        return this.$moment(this.item.order.date).format('YYYY-MM-DD HH:mm');
      },
    },
    async mounted() {
     // console.log('idWharhouse----',this.idWharhouse)
//       JsBarcode("#barcode", "1234", {
//   format: "pharmacode",
//   lineColor: "#0aa",
//   width:4,
//   height:40,
//   displayValue: false
// });
  //JsBarcode("#"+this.traking, this.traking, {format: "code39", fontOptions: "bold",height:40,});
      // const statusId = await this.getStatusByName("Confirmed");
      //  const res = await this.$server.get("statusHistories", {
      //   order: this.item.order._id,
      //   status:statusId
      // });
      //  if (res.content) {
      //    this.usernameTeleconsul=res.content.user.email;
      //    if(res.content.user.username)  this.usernameTeleconsul=res.content.user.username;
      //  }
      //console.log('item _ddd',this.item)
     // this.image=await `https://barcode.tec-it.com/barcode.ashx?data=${this.item.trackingNumber}&code=Code128&multiplebarcodes=false&translate-esc=false&unit=Fit&dpi=96&imagetype=Gif&rotation=0&color=%23000000&bgcolor=%23ffffff&qunit=Mm&quiet=0`;
    },
    methods: {
       execProductName(name) {
         if(name.length>15) return name.substring(0, 10) + "...";
         else return name;
        
      }, 
     async getStatusByName(name) {
        const result = await this.$server.get("status",{ name: name });
        return result.content._id;
     },
    }    
}
</script>

<style scoped>
.qr-wrapper {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
}

.qr-wrapper-small {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 1px;
}

/* Print Optimization */
@media print {
  .qr-wrapper canvas,
  .qr-wrapper-small canvas {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    page-break-inside: avoid;
  }
  
  .modalprint table {
    page-break-inside: auto;
  }
  
  .modalprint tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
} 
</style>

